const TitleStripe = ({ children, className = "", isGray = false, badge }) => {
  return (
    <div className={`w-full mt-10 ${className}`}>
      {badge && (
        <div className="text-[10px] font-semibold tracking-[0.25em] text-blue-600 uppercase mb-1">
          {badge}
        </div>
      )}
      <div className="relative w-full">
        <div className="absolute inset-0 top-1/2 border-t border-gray-300"></div>
        <div
          className={`relative z-10 inline-block pr-6 mx-auto text-gray-800 text-base md:text-lg font-semibold tracking-widest uppercase ${
            isGray ? "bg-gray-50" : "bg-white"
          }`}
        >
          {children}
        </div>
      </div>
    </div>
  );
};

export default TitleStripe;
